import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { FormattedMessage } from 'react-intl';
import PATHS from 'constants/paths';

const HostModifyBookingSection = ({ booking, disableButtons }) => {
  const [supportOpen, setSupportOpen] = React.useState(false);
  const hostEntry = booking.host_change_booking_entry;
  const showEditOfferLink = hostEntry === 'edit';
  const showSupportUi = hostEntry === 'support';

  if (!showEditOfferLink && !showSupportUi) {
    return null;
  }

  const editOfferPath = PATHS.conversations.editBookingOffer
    .replace(':conversationId', booking.conversation_id)
    .replace(':bookingId', booking.id);

  return (
    <Box mb={2} mt={4}>
      <Typography variant="subtitle2">
        <FormattedMessage id="bookingForm.update" defaultMessage="Modify booking" />
      </Typography>
      {showEditOfferLink && (
        <Typography paragraph>
          <FormattedMessage
            id="booking.updateExplanation"
            defaultMessage="Change dates, total price, or the offer expiration date using the button below."
          />
        </Typography>
      )}
      <Box display="flex" flexWrap="wrap" alignItems="center">
        {showEditOfferLink && (
          <Box mr={1} mb={1}>
            <Button
              variant="contained"
              color="primary"
              disabled={disableButtons}
              component={Link}
              to={editOfferPath}
            >
              <FormattedMessage id="bookingInfo.changeOffer" defaultMessage="Change" />
            </Button>
          </Box>
        )}
        {showSupportUi && (
          <Box mr={1} mb={1}>
            <Button
              variant="contained"
              color="primary"
              disabled={disableButtons}
              onClick={() => setSupportOpen(true)}
            >
              <FormattedMessage id="bookingInfo.changeOffer" defaultMessage="Change" />
            </Button>
          </Box>
        )}
      </Box>
      <Dialog open={supportOpen} onClose={() => setSupportOpen(false)}>
        <DialogTitle>
          <FormattedMessage id="bookingForm.update" defaultMessage="Modify booking" />
        </DialogTitle>
        <DialogContent>
          <Typography>
            <FormattedMessage
              id="bookingInfo.paidChangeSupportMessage"
              defaultMessage="Want to rebook or make changes to an already paid booking? Contact Stugknuten support at {email}."
              values={{
                email: <a href="mailto:info@stugknuten.com">info@stugknuten.com</a>,
              }}
            />
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSupportOpen(false)} color="primary">
            <FormattedMessage id="Close" defaultMessage="Close" />
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

HostModifyBookingSection.propTypes = {
  booking: PropTypes.shape({
    conversation_id: PropTypes.number.isRequired,
    id: PropTypes.number.isRequired,
    host_change_booking_entry: PropTypes.oneOf(['edit', 'support']),
  }).isRequired,
  disableButtons: PropTypes.bool,
};

HostModifyBookingSection.defaultProps = {
  disableButtons: false,
};

export default HostModifyBookingSection;
